import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';

export interface HealthStatus {
  status: 'healthy' | 'unhealthy' | 'degraded';
  message?: string;
  timestamp?: string;
  services?: {
    [key: string]: 'up' | 'down';
  };
}

@Injectable({ providedIn: 'root' })
export class HealthService {
  constructor(private apiService: ApiService) {}

  /**
   * Get system health status
   */
  getHealth(skipGlobalLoader = false): Observable<HealthStatus> {
    return this.apiService.get<HealthStatus>('/health', undefined, true, skipGlobalLoader);
  }
}
